// extracted by mini-css-extract-plugin
export default {"addToCartControl":"m0-z","giftCard":"n0-z","btnContainer":"o0-z","cartButton":"p0-z","disabled":"q0-z"};